import React, { Component } from 'react'
import { connect } from 'react-redux'
import ContainerWithTitleWrapper from '../../HOC/ContainerWithTitle'
import { Grid, Button } from '@material-ui/core'
import { syncInsightsPermissions } from '../../../actions/insights'

const GridItem = ({ children }) => (
  <Grid item xs={12} sm={12} md={12} lg={12} style={{ margin: 10 }}>
    {children}
  </Grid>
)

class SyncInsights extends Component {
  constructor(props) {
    super(props)

    const lastSyncTime = localStorage.getItem('lastSyncTime')

    this.state = {
      lastSyncTime: lastSyncTime ? new Date(Number(lastSyncTime)) : null,
      syncStatus: null,
      intervalId: null,
    }
  }

  componentDidMount() {
    const intervalId = setInterval(() => this.updateSyncStatus(), 30000)
    this.setState({ intervalId })
  }

  componentWillUnmount() {
    clearInterval(this.state.intervalId)
  }

  getSession() {
    if (window && window.localStorage) {
      return window.localStorage.getObject('session')
    }

    return null
  }

  updateSyncStatus = () => {
    const { lastSyncTime } = this.state
    if (lastSyncTime) {
      const minutesSinceLastSync = Math.floor((Date.now() - lastSyncTime.getTime()) / 60000)
      let syncStatus

      if (minutesSinceLastSync >= 20) {
        syncStatus = (
          <span>
            <strong>Sync status:</strong> Completed
          </span>
        )
        clearInterval(this.state.intervalId)
      } else {
        syncStatus = (
          <span>
            <strong>Time elapsed:</strong> {minutesSinceLastSync} minute(s)
          </span>
        )
      }

      this.setState({ syncStatus })
    }
  }

  syncInsightsPermissionsAsync = async (employeeId) => {
    const currentTime = new Date()
    //Start time
    this.setState({ lastSyncTime: currentTime })
    localStorage.setItem('lastSyncTime', currentTime.getTime().toString())
    await this.props.dispatch(syncInsightsPermissions(employeeId))
  }

  render() {
    const hasInsightsPermissions =
      this.props.companyReducer &&
      this.props.companyReducer.companyFeatures &&
      this.props.companyReducer.companyFeatures.hasAnyInsightsRole
    const { syncStatus } = this.state
    const session = this.getSession()
    const { employee } = session || {}
    const { role } = employee || {}
    const isAdmin = role.roleLevel === 'ADMIN'
    let messageTitle, employeeId, buttonMessage
    //Different message for admins and people with roles.
    if (isAdmin) {
      employeeId = ''
      messageTitle =
        'Having issues with your employees permissions and roles related to Blaze Insights?'
      buttonMessage = 'Synchronize company insights permissions'
    } else if (hasInsightsPermissions) {
      employeeId = employee.id
      messageTitle =
        'Having issues with your employee permissions and roles related to Blaze Insights?'
      buttonMessage = 'Synchronize my insights permissions'
    }
    //TODO: FIX REFRESH TIME FOR THE STATE

    return (
      <Grid container className="margin-top-small" style={{ backgroundColor: 'white' }}>
        <GridItem>
          <h3>{messageTitle}</h3>
        </GridItem>
        <GridItem>
          <span>
            Our most sincere apologies. Please, synchronize your data using the following button.
          </span>
        </GridItem>
        <GridItem>
          <Button
            variant="raised"
            className="primary-button pull-left margin-bottom-small"
            onClick={() => {
              this.syncInsightsPermissionsAsync(employeeId)
            }}
          >
            {buttonMessage}
          </Button>
        </GridItem>
        <GridItem>
          <span>
            <strong>Note:</strong> Please be aware that synchronization takes up to 20 minutes. If
            you are still experiencing issues after the synchronize process, please reach out to
            Customer Support.
          </span>
        </GridItem>
        <GridItem>{syncStatus}</GridItem>
      </Grid>
    )
  }
}

const SyncInsightsPermissionsWithTitle = ContainerWithTitleWrapper(
  SyncInsights,
  'Sync Company permissions with Blaze Insights',
)

const SyncInsightsConnected = connect(({ shopReducer, dispatch, authReducer, companyReducer }) => ({
  shopReducer,
  dispatch,
  authReducer,
  companyReducer,
}))(SyncInsightsPermissionsWithTitle)

export default SyncInsightsConnected



// WEBPACK FOOTER //
// ./src/containers/Settings/Insights/InsightsSync.js